import React from 'react'
import validator from 'validator'
import { ErrorMessage } from '../common/ErrorMessage'
import { UppercaseInput } from '../common/Input/UppercaseInput'
import { FormControlWrapper } from '../FormControlWrapper'
import { FormControlValidIcon } from '../FormControlValidIcon'

export class PassportLineOne extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange = (event) => {
    this.handleValidation(event)
    this.props.onChange(event)
  }

  handleValidation = (event) => {
    let message = validator.matches(
      event.target.value.toUpperCase(),
      /^([P|p])(<)([G|g][B|b][R|r])([A-Za-z]{2})[(A-Za-z)<]{37}$/,
    )
      ? ''
      : 'Please ensure your passport line one is valid'

    this.props.handleValidation(event.target.name, message)
  }
  render() {
    return (
      <>
        <FormControlWrapper>
          <FormControlValidIcon
            error={this.props.error}
            className='fas fa-check'
          ></FormControlValidIcon>
          <UppercaseInput
            placeholder='The first line of my passport says...'
            onChange={this.handleChange}
            name='PassportLineOne'
            error={this.props.error}
            value={this.props.value}
          />
        </FormControlWrapper>
        <ErrorMessage>{this.props.error}</ErrorMessage>
      </>
    )
  }
}
